module.exports = __webpack_public_path__ + "img/airplane.cbf74d5c.png";